import { render, staticRenderFns } from "./UrgentRecord.vue?vue&type=template&id=56591a91&"
import script from "./UrgentRecord.vue?vue&type=script&lang=js&"
export * from "./UrgentRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports